module.exports = __webpack_public_path__ + "static/media/donation.b97f0e19.png";